import { render } from "./AdminLandingPages.vue?vue&type=template&id=0513e61d&scoped=true"
import script from "./AdminLandingPages.vue?vue&type=script&lang=js"
export * from "./AdminLandingPages.vue?vue&type=script&lang=js"

import "./AdminLandingPages.vue?vue&type=style&index=0&id=0513e61d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0513e61d"]])

export default __exports__